import Vue from 'vue'
import Vuex from 'vuex'
import cookie from "@/service/cookieUtil";
import axiosHelper from "@/plugins/axiosHelper";

Vue.use(Vuex);
Vue.use(axiosHelper, { includeTokenHeader: false, axiosConfig: null });

export default new Vuex.Store({
    state: {
        drawer: false,
        currentUser: null,
        secretKey: process.env.VUE_APP_AES_SECRET_KEY,
        iv: process.env.VUE_APP_AES_IV,
        menuItemList: [
            {title: '홈', name: 'Home', isAllowMobile: true, isShow: true, requiredAuth: false},
            {title: '방문신청하기', name: 'AgreeTerms', isAllowMobile: true, isShow: true, requiredAuth: false},
            {title: '방문신청조회', name: 'Search', isAllowMobile: true, isShow: true, requiredAuth: false},
            // {title: '공지사항', name: 'News', isAllowMobile: true, isShow: true, requiredAuth: false},
            {title: '백오피스', href: '/backoffice', isAllowMobile: false, isShow: false, requiredAuth: true},
            {title: '방문교육', href: '/education', isAllowMobile: true, isShow: true, requiredAuth: false},
        ],
        vStep: 1,
        stepInfos: {
            step1: '',
            step2: '',
            step3: ''
        },
        termsAgreements: [],
        terms: [],
        searchParam: null,


        // TODO 필요한가?
        apply: {
            step1: null
        }
    },

    mutations: {
        SET_DRAWER(state, payload) {
            state.drawer = payload
        },
        setStep(state, payload) {
            state.vStep = payload;
        },
        setStepInfo1(state, payload) {
            state.stepInfos.step1 = payload;
        },
        setStepInfo2(state, payload) {
            state.stepInfos.step2 = payload;
        },
        setStepInfo3(state, payload) {
            state.stepInfos.step3 = payload;
        },
        currentUser(state, payload) {
            state.currentUser = payload;
        },
        setTermsAgreements(state, payload) {
            state.termsAgreements = payload;
        },
        setTerms(state, payload) {
            state.terms = payload;
        },
        setSearchParam(state, payload) {
            state.searchParam = payload;
        }
    },

    actions: {
         fetchCurrentUser: async (context) => {
             let accessToken = cookie.get('access_token');

             try {
                 if (accessToken === null) await Vue.prototype.$axios.refreshToken();

                 accessToken = cookie.get('access_token');
                 if (accessToken === null) {
                     context.commit('currentUser', null);
                     return;
                 }

                 if (!context.state.currentUser) {
                     const result = await Vue.prototype.$axios.get('/v1/home/user/current', {
                         headers: {'Authorization': `Bearer ${accessToken}`}
                     })
                     context.commit('currentUser', result.data);
                 }
             } catch(err) {
                 context.commit('currentUser', null);
                 throw err;
             }
        },

        logout: () => {
            cookie.delete('access_token');
            cookie.delete('refresh_token');
        }
    },

    modules: {}

})
